import { render, staticRenderFns } from "./SchemaFieldListGrouped.vue?vue&type=template&id=37cb6415&"
import script from "./SchemaFieldListGrouped.vue?vue&type=script&lang=js&"
export * from "./SchemaFieldListGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports